module.exports = __webpack_public_path__ + "media/images/icon_a2-17aa668b74f9effda72a6cf4ad62ac18.png";